export function aboutVideo() {
  const videos = document.querySelectorAll('.about__video');

  videos.forEach(container => {
    const video = container.querySelector('.about__video-file');
    const playBtn = container.querySelector('.about__video-play-btn');

    const togglePlay = () => {
      if (video.paused) {
        video.play();
        container.classList.add('about__video--active');
        playBtn.style.display = 'none';
      } else {
        video.pause();
        container.classList.remove('about__video--active');
        playBtn.style.display = 'block';
      }
    };

    playBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      togglePlay();
    });

    container.addEventListener('click', (e) => {
      togglePlay();
    });

    video.addEventListener('ended', () => {
      container.classList.remove('about__video--active');
      playBtn.style.display = 'block';
    });
  });
}
